(function () {
  function hasAnalyticsConsent() {
    const customerPrivacy = window.Shopify?.customerPrivacy;

    if (!customerPrivacy?.currentVisitorConsent) {
      return false;
    }

    return customerPrivacy.currentVisitorConsent().analytics !== 'no';
  }

  function getCartUrl() {
    const cartUrl = window.theme?.routes?.cart_url || '/cart';

    return `${cartUrl}.js`;
  }

  function publishCartDrawerViewed(cart) {
    if (!hasAnalyticsConsent()) {
      return;
    }

    const publish = window.Shopify?.analytics?.publish;

    if (typeof publish !== 'function') {
      return;
    }

    return publish.call(window.Shopify.analytics, 'groundies:cart_drawer_viewed', { cart });
  }

  function trackViewCart() {
    fetch(getCartUrl(), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch cart');
        }

        return response.json();
      })
      .then(publishCartDrawerViewed)
      .catch(() => {});
  }

  document.addEventListener('cart-drawer:open', trackViewCart);
})();
